import React, {Component} from 'react'
import PropTypes from "prop-types"

class SearchNumberBox extends Component {
    timeout = 0

    _handleChangeInput = (e) => {
        const {value} = e.target

        const {onChange, onSubmit} = this.props
        const arrIDs = value.split(/\r|\n|\t|\r\n|\s|,\s|,/)
        const newArrIds = arrIDs.map(box => {
            if(box.includes('#')) return box.replace('#', '')    
                
            return box
        }).filter(item => item !== '')
        
        onChange('box_ids', newArrIds)

        if (this.timeout) clearTimeout(this.timeout)

        this.timeout = setTimeout( () => {
            if (typeof onSubmit === 'function' && typeof onChange === 'function') {
                onSubmit()
            }
        }, 1000)
    }

    render() {
        const {filter} = this.props
        const {box_id} = filter

        return (
            <div className="SearchByIdBox  mr-3 mb-2">
                <label htmlFor="" className='mb-0 font-weight-bold'>Số thùng</label>
                <input value={box_id === 0 ? '' : box_id} onChange={this._handleChangeInput}
                       className="form-control"
                       placeholder="Nhập số thùng ..."/>
            </div>
        )
    }
}

SearchNumberBox.propTypes = {
    box_id: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
}

export default SearchNumberBox
